import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { BadgeCheckIcon, XIcon } from 'lucide-react';
import { images, recentBuyers } from '../data/landing';
const FIRST_DELAY = 6000;
const VISIBLE_FOR = 5000;
const INTERVAL = 14000;
export function PurchasePopup() {
  const [index, setIndex] = useState<number | null>(null);
  const [minutesAgo, setMinutesAgo] = useState(2);
  const [dismissed, setDismissed] = useState(false);
  useEffect(() => {
    if (dismissed) return;
    let hideTimer: number;
    let count = 0;
    const show = () => {
      setIndex(count % recentBuyers.length);
      setMinutesAgo(1 + Math.floor(Math.random() * 9));
      count += 1;
      hideTimer = window.setTimeout(() => setIndex(null), VISIBLE_FOR);
    };
    const first = window.setTimeout(show, FIRST_DELAY);
    const loop = window.setInterval(show, INTERVAL);
    return () => {
      window.clearTimeout(first);
      window.clearTimeout(hideTimer);
      window.clearInterval(loop);
    };
  }, [dismissed]);
  const buyer = index !== null ? recentBuyers[index] : null;
  return <div className="pointer-events-none fixed bottom-[104px] left-3 right-3 z-50 sm:right-auto sm:w-[360px] md:bottom-6 md:left-6" aria-live="polite" data-id="element-42" data-mp="115ute5uefyqb">
      <AnimatePresence data-id="element-43" data-mp="1awpidhz15cfg">
        {buyer && !dismissed && <motion.div key={buyer.name} initial={{
        opacity: 0,
        y: 16,
        scale: 0.96
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: 16,
        scale: 0.96
      }} transition={{
        duration: 0.22,
        ease: [0.23, 1, 0.32, 1]
      }} className="pointer-events-auto relative flex items-center gap-3 rounded-2xl bg-white p-3 pr-9 shadow-[0_12px_32px_rgba(11,31,58,0.18)] ring-1 ring-navy/10" data-id="element-44" data-mp="1ax7mt1vuiwyg">
            <img src={images.product} alt="" className="h-14 w-14 shrink-0 rounded-xl bg-sky-pale object-cover" data-id="element-45" data-mp="28jok474kxak7" />
            <div className="min-w-0" data-id="element-46" data-mp="23kbnwvrtir4y">
              <p className="text-sm leading-snug text-navy" data-id="element-47" data-mp="23nhao4cz5gxi">
                <strong data-id="element-48" data-mp="2anjlrmvdglaz">{buyer.name}</strong> from <strong data-id="element-49" data-mp="2aqnsos081v5c">{buyer.country}</strong> just purchased the digital book
              </p>
              <p className="mt-0.5 flex items-center gap-1 text-xs font-semibold text-cta" data-id="element-50" data-mp="2fpr1mnjbolil">
                <BadgeCheckIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-51" data-mp="2knip95cxplgz" />
                Verified · {minutesAgo} min ago
              </p>
            </div>
            <button type="button" onClick={() => setDismissed(true)} className="absolute right-2 top-2 rounded-full p-1 text-muted transition-colors duration-150 hover:bg-canvas hover:text-navy" aria-label="Close notification" data-id="element-52" data-mp="1ryv377kd2s2d">
              <XIcon className="h-4 w-4" data-id="element-53" data-mp="26n7ye2bmk6vt" />
            </button>
          </motion.div>}
      </AnimatePresence>
    </div>;
}